import { call, select, put } from 'redux-saga/effects';
import api from '../../../../../../../services/api';
import { getLoadedTimelinePeriod } from '../../selectors';
import { scheduleActions } from '../../actions';
import moment from 'moment/moment';

export function* fetchExtensionPeriodEntries() {
  const loadedTimelinePeriod = yield select(getLoadedTimelinePeriod);
  const from = moment(loadedTimelinePeriod.start).unix();
  const to = moment(loadedTimelinePeriod.end).unix();

  try {
    const response = yield call(api.get, `v1/extension-periods?range_start=${from}&range_end=${to}`)
    if (response.status === 200) {
      const entries = response.data?.Data
      yield put(scheduleActions.setExtensionPeriodTimelineEntries(entries || []))
    }
  } catch (e) {
    console.error("Failed to fetch extension period entries")
  }
}

export function* fetchExtensionEntry(entryId: string) {
  try {
    const response = yield call(api.get, `v1/extension-periods/${entryId}`);
    if (response.status === 200) {
      return response.data?.Data
    }
  } catch (e) {
    console.error("Failed to fetch extension entry", e);
  }
}
